import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["loading", "dropdown", "label", "menu", "radio"]

  connect() {
    this.fetchCalendars();
  }

  disconnect() {
    if (this.fetchXhr) {
      try { this.fetchXhr.abort(); } catch (_e) {}
      this.fetchXhr = null;
    }
  }

  fetchCalendars() {
    var controller = this;
    var url = this.element.dataset.googleCalendarSingleSelectUrl;

    this.fetchXhr = $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (data) {
        controller.fetchXhr = null;
        controller.buildDropdown(data.calendars);
        controller.loadingTarget.classList.add("d-none");
        controller.dropdownTarget.classList.remove("d-none");

        var dirtyFormEl = controller.element.closest("[data-controller*='google-dirty-form']");
        if (dirtyFormEl) {
          var dirtyForm = controller.application.getControllerForElementAndIdentifier(dirtyFormEl, "google-dirty-form");
          if (dirtyForm) dirtyForm.resetInitialState();
        }
      },
      error: function (xhr) {
        controller.fetchXhr = null;
        if (xhr.statusText === "abort") return;
        controller.loadingTarget.innerHTML = '<span class="text-danger">Unable to load calendars.</span>';
      },
    });
  }

  buildDropdown(calendars) {
    var selectedId = this.element.dataset.googleCalendarSingleSelectSelectedId;
    var connectionId = this.element.dataset.googleCalendarSingleSelectConnectionId;
    var $menu = $(this.menuTarget);
    var selectedName = "Primary Calendar";
    var readOnlyHeaderAdded = false;

    calendars.forEach(function (cal) {
      var name = cal[0];
      var calId = cal[1];
      var readOnly = cal[2] && cal[2].readOnly;
      var isSelected = calId === selectedId;

      if (isSelected) selectedName = name;

      if (readOnly && !readOnlyHeaderAdded) {
        var $header = $('<div class="dropdown-header bg-light text-muted d-flex align-items-center"></div>');
        $header.append('<i class="fas fa-triangle-exclamation mr-2"></i>');
        $header.append(document.createTextNode("Read only — These calendar are read-only. Events can be viewed but cannot be created, updated, or deleted."));
        $menu.append($header);
        readOnlyHeaderAdded = true;
      }

      if (readOnly) {
        var $item = $('<span class="dropdown-item-text text-muted bg-light d-flex justify-content-between align-items-center"></span>');
        $item.append(document.createTextNode(name));
        $item.append($('<span class="badge badge-danger ml-2"></span>').text("Read Only"));
        $item.on("click", function (e) {
          e.stopPropagation();
        });
        $menu.append($item);
        return;
      }

      var radioId = "cal-" + connectionId + "-" + calId.replace(/[^a-zA-Z0-9-]/g, "-");
      var $input = $('<input type="radio" class="d-none" />')
        .attr("name", "google_connection[calendar_id]")
        .attr("value", calId)
        .attr("id", radioId)
        .attr("data-target", "google-calendar-single-select.radio")
        .attr("data-action", "change->google-calendar-single-select#changed")
        .prop("checked", isSelected);
      var $label = $('<label class="dropdown-item"></label>')
        .attr("for", radioId)
        .toggleClass("active", isSelected)
        .text(name);

      $menu.append($input).append($label);
    });

    this.labelTarget.textContent = selectedName;
  }

  changed() {
    this.radioTargets.forEach((r) => {
      const label = this.element.querySelector(`label[for="${r.id}"]`);
      if (label) label.classList.toggle("active", r.checked);
    });

    const selected = this.radioTargets.find((r) => r.checked);
    if (selected) {
      const label = this.element.querySelector(`label[for="${selected.id}"]`);
      this.labelTarget.textContent = label
        ? label.textContent.trim()
        : selected.value;
    }
  }
}
